module.exports = {"data":{"site":{"siteMetadata":{"siteName":"Healthful&Inspired","siteUrl":"https://healthfulinspired.com","siteDescription":"Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/kettlebell-swings"},"frontmatter":{"title":"Kettleball Swings","date":null}}}]}},"pathContext":{"tag":"kettleball-swings"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-kettleball-swings.json
// module id = 3369
// module chunks = 18040748778310